import { useAuth } from 'react-oidc-context';

// El token ahora vive en el contexto de react-oidc-context, que lo renueva en
// segundo plano antes de que expire. Esto reemplaza a fetchAuthSession() de
// Amplify, que había que llamar en cada petición.
//
// La forma del hook no cambia —{ token, setToken }— para que los 26
// consumidores sigan igual. setToken queda como no-op: la sesión la gobierna
// el proveedor, y dejar que un componente la pisara era justo el problema que
// tenía la versión anterior, con el token duplicado en localStorage.
export default function useToken() {
  const auth = useAuth();
  return {
    token: auth.user?.access_token || null,
    setToken: () => {},
    refreshToken: () => auth.signinSilent(),
  };
}

// Para código fuera de componentes que necesita un token puntual. Antes esto
// era obtenerToken() con fetchAuthSession; ahora lee la sesión que el proveedor
// ya guardó, sin llamadas de red.
export async function obtenerToken() {
  try {
    const { User } = await import('oidc-client-ts');
    const { oidcConfig } = await import('./auth-config.js');
    const clave = `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`;
    const crudo = sessionStorage.getItem(clave) || localStorage.getItem(clave);
    if (!crudo) return null;
    return User.fromStorageString(crudo)?.access_token || null;
  } catch (e) {
    console.log('obtenerToken', e);
    return null;
  }
}
